import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '918099975662';
  const defaultMessage = 'Hello Taiga Sourcing, I would like to discuss a sourcing requirement from India.';

  const handleSendMessage = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(defaultMessage)}`;
    window.open(url, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="whatsapp-widget">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="mb-4 w-80 bg-white shadow-2xl overflow-hidden border border-[#E5E0D8]"
          >
            <div className="bg-[#0B2A57] p-4">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-white text-sm font-semibold">Taiga Sourcing</h3>
                  <p className="text-white/60 text-xs">Multi-Category Sourcing from India</p>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="text-white/60 hover:text-white"
                  data-testid="whatsapp-close"
                >
                  <X size={18} />
                </button>
              </div>
            </div>
            <div className="p-4 bg-[#fafaf9]">
              <div className="bg-white p-3 text-sm text-[#6B7280] shadow-sm border border-[#E5E0D8]">
                Hello! How can we help with your India sourcing requirement?
              </div>
            </div>
            <div className="p-4">
              <button
                onClick={handleSendMessage}
                className="w-full py-3 bg-[#25D366] text-white text-sm font-semibold tracking-wider uppercase hover:bg-[#20BD5A] transition-colors flex items-center justify-center gap-2"
                data-testid="whatsapp-send"
              >
                <MessageCircle size={18} />
                Start Conversation
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setIsOpen(!isOpen)}
        className="w-14 h-14 bg-[#25D366] text-white shadow-lg flex items-center justify-center hover:bg-[#20BD5A] transition-colors rounded-full"
        data-testid="whatsapp-toggle"
      >
        {isOpen ? <X size={24} /> : <MessageCircle size={24} />}
      </motion.button>
    </div>
  );
};

export default WhatsAppWidget;
